import { createCommand } from './plugin-state';
export var updateStickyState = function updateStickyState(rowState) {
  return createCommand({
    name: 'UPDATE',
    state: rowState
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};
export var removeStickyState = function removeStickyState(pos) {
  return createCommand({
    name: 'REMOVE',
    pos: pos
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};